import React from 'react';
import i18n from '../../../../i18n';
import swal from 'sweetalert';
import { SideBar } from '../../sidebar';
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import { auctionReject, getDeliveryAuctions } from './services/auctionApprovalServices';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import DataTable from 'react-data-table-component';
import { withRouter } from '../../../../hoc/withRouter';
import { WarningBox } from '../../../common/WarningBox';
import { DELIVERY_STATUS, DeliveryStatus } from '../../../../constants/status';
import StatusBadge from '../../../common/StatusBadge';
import '../../../../styles/pages/auction-approval-details.scss';
import AvatarIcon from '../../../common/AvatarIcon';
import { apiUrl, imageUrl } from '../../../../constants/global';
import { ConfirmModal } from '../../../common/ConfirmModal';
import { AuctionApproveModal } from './components/AuctionApproveModal';
import { swapWallet } from '../../../../models/auctionDelivery';
import { AuctionFundDeductModal } from './components/AuctionFundDeduct';
import { ArrowLeft, Download, FileSpreadsheet, Printer } from 'lucide-react';
import { AuctionSettleModal } from './components/AuctionSettleModal';
import { getLoggedUser } from '../../../../state/user';
import HeaderBanner from '../../../common/HeaderBanner';
import NewDropdown from '../../../common/NewDropDown';
import { downloadFile } from '../../../../utils/downloadFile';
import ExpandableText from '../../../common/ExpandableText';
import { BulkFundDeductList } from './components/BulkFundDeductList';

const user = getLoggedUser();

class AuctionApprovalDeatil extends React.Component {
  constructor() {
    super();
    this.state = {
      groupId: null,
      deliveryAuctions: [],
      meta: {
        organization: { name: '', image_url: null },
        group: {},
        total_records: 0,
        grand_total: 0,
      },
      selectedIds: [],
      selectedRows: [],
      selectedRow: null,
      selectedSum: 0,
      paymentApproval: {},
      is_loading: false,
      hideSidebar: false,
      exportLoading: false,
      showBulkDeduct: false,
      limit: 15,
      page: 1,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const { groupId } = this.props.params;
    // Parse URL query params
    const params = new URLSearchParams(this.props.location.search);
    const status = params.get('status') || 'pending';
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;

    this.setState({ groupId, status, page, limit }, () => {
      this.getDeliveryAuctions();
    });
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    const url = `/auction_approval/${this.state.groupId}?${queryString}`;
    window.history.replaceState(null, '', url);
  }

  isSwapDisabled(row) {
    if (!row) return true;

    const total = Number(row.total_amount) || 0;
    const client = Number(row.client_amount) || 0;
    const wallet = Number(row.wallet_amount) || 0;

    // Disable if total is invalid
    if (total <= 0) return true;

    // Disable if client already covers or exceeds total
    if (client >= total) return true;

    // Disable if wallet has no funds
    if (wallet <= 0) return true;

    const remaining = total - client;

    // Disable if wallet cannot cover remaining amount
    return wallet < remaining;
  }
  getColumns = () => {
    const { deliveryAuctions, selectedIds, status } = this.state;
    const hasApproved = deliveryAuctions.some(
      (row) =>
        ![DeliveryStatus['pending'], DeliveryStatus['rejected']].includes(row.delivery_status)
    );
    const hasFundAdded = deliveryAuctions.some(
      (row) => row.delivery_status === DeliveryStatus['fundAdded']
    );
    const hasCompleted = deliveryAuctions.some(
      (row) => row.delivery_status === DeliveryStatus['financeSettled']
    );
    let columns = [
      {
        id: 'select',
        name:
          (status === 'pending' && (user.role === 'PM' || user.role === 'C')) ||
          (status === 'fundAdded' && user.role === 'F') ||
          (status === 'fundDeduct' && user.role === 'F') ? (
            <input
              type="checkbox"
              checked={
                deliveryAuctions.length > 0 &&
                selectedIds.length > 0 &&
                selectedIds.length === deliveryAuctions.length
              }
              onChange={() => this.handleCheckAll(deliveryAuctions)}
              aria-label="Select all eligible rows"
            />
          ) : null,
        cell: (row) => {
          const isSelectable =
            (status === 'pending' && (user.role === 'PM' || user.role === 'C')) ||
            (status === 'fundAdded' && user.role === 'F') ||
            (status === 'fundDeduct' && user.role === 'F');

          // Disable logic: only for fundAdded
          const isDisabled =
            status === 'fundAdded' &&
            Number(row.client_amount) < Number(row.total_amount) &&
            Number(row.paid_amount) === Number(row.total_amount);

          return isSelectable ? (
            <input
              type="checkbox"
              checked={selectedIds.includes(row.id)}
              onChange={() => this.handleCheckboxChange(row)}
              aria-label={`Select row ${row.id}`}
              disabled={isDisabled}
            />
          ) : null;
        },
        width: '60px',
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
      {
        name: 'Sl No',
        sortable: true,
        wrap: true,
        width: '80px',
        cell: (row, i) => i + 1,
      },
      {
        name: 'ID',
        sortable: true,
        wrap: true,
        width: '100px',
        cell: (row) => <span className="highlight-table-value">MZAD {row.id}</span>,
      },
      {
        name: i18n.t('auction'),
        minWidth: '150px',
        maxWidth: '250px',
        cell: (row) => row.title,
      },
      {
        name: i18n.t('winner'),
        width: '200px',
        cell: (row) => (
          <div>
            <div>
              <strong>{row.winner}</strong>
            </div>
            {user.role !== 'C' && (
              <>
                <div style={{ fontSize: '14px', color: '#666' }}>
                  Balance: {row.wallet_amount ?? 0}
                </div>
                <div style={{ fontSize: '14px', color: '#666' }}>
                  Client Amount: {row.client_amount ?? 0}
                </div>
              </>
            )}
            {hasFundAdded && user.role === 'F' && (
              <button
                className="button-table"
                disabled={this.isSwapDisabled(row)}
                onClick={() => this.setState({ showSwap: true, selectedRow: row })}
              >
                {i18n.t('swap')}
              </button>
            )}
          </div>
        ),
        wrap: true,
      },
      {
        width: '220px',
        name: i18n.t('bid_details'),
        key: 'bid_details',
        wrap: true,
        cell: (row) => (
          <div style={{ fontSize: '13px', lineHeight: '1.4' }}>
            <div className="hitch">
              <strong>Final Bid Amt:</strong> {row.bid_amount.toFixed(2) ?? 0}
            </div>
            <div className="hitch hitch-sub">
              <span>Service Charge:</span> {row.service_charge ?? 0}
            </div>
            <div className="hitch hitch-sub">
              <span>Service VAT:</span> {row.vat_service_charge ?? 0}
            </div>
            <div className="hitch hitch-sub ">
              <span>Item VAT:</span> {row.item_amount_vat ?? 0}
            </div>
            <div
              className="hitch hitch-total"
              style={{
                borderTop: '1px solid #ddd',
                marginTop: '4px',
                paddingTop: '4px',
                fontWeight: 'bold',
                color: '#111',
              }}
            >
              <span>Total Bidder Amt:</span>{' '}
              <span className="float-right">{row.total_amount ?? 0}</span>
            </div>
          </div>
        ),
      },
      {
        width: '240px',
        name: i18n.t('client_amount'),
        wrap: true,
        omit: false,
        cell: (row) => {
          const collectionType = Number(row.collection_type);

          // Only show breakdown for collection_type 1 (Full Amount) or 2 (Bid Amount)
          if (collectionType === 3) {
            // Compute all values safely
            const bidAmount = 0;
            const serviceCharge = Number(row.service_charge) || 0;
            const serviceVat = Number(row.vat_service_charge) || 0;
            const itemVat = 0;

            // Auto calculate total (if backend doesn't provide total_amount)
            const totalAmount = bidAmount + serviceCharge + serviceVat + itemVat;
            return (
              <div style={{ fontSize: '13px', lineHeight: '1.4' }}>
                <div className="hitch">
                  <strong>Final Bid</strong>{' '}
                  <span className="float-right">{bidAmount.toFixed(2)}</span>
                </div>

                <div className="hitch hitch-sub">
                  <span>Service Charge</span>{' '}
                  <span className="float-right">{serviceCharge.toFixed(2)}</span>
                </div>

                <div className="hitch hitch-sub">
                  <span>Service VAT</span>{' '}
                  <span className="float-right">{serviceVat.toFixed(2)}</span>
                </div>

                <div className="hitch hitch-sub">
                  <span>Item VAT</span> <span className="float-right">{itemVat.toFixed(2)}</span>
                </div>

                <div
                  className="hitch hitch-total"
                  style={{
                    borderTop: '1px solid #ddd',
                    marginTop: '4px',
                    paddingTop: '4px',
                    fontWeight: 'bold',
                    color: '#111',
                  }}
                >
                  <span>Total Client Amt:</span>{' '}
                  <span className="float-right">{totalAmount.toFixed(2)}</span>
                </div>
              </div>
            );
          }
          // Compute all values safely
          const bidAmount = Number(row.bid_amount) || 0;
          const serviceCharge = row.is_service_charge_included
            ? Number(row.service_charge) || 0
            : 0;
          const serviceVat = row.is_service_charge_vat_included
            ? Number(row.vat_service_charge) || 0
            : 0;
          const itemVat = row.is_vat_included ? Number(row.item_amount_vat) || 0 : 0;

          // Auto calculate total (if backend doesn't provide total_amount)
          const totalAmount = bidAmount + serviceCharge + serviceVat + itemVat;

          return (
            <div style={{ fontSize: '13px', lineHeight: '1.4' }}>
              <div className="hitch">
                <strong>Final Bid</strong>{' '}
                <span className="float-right">{bidAmount.toFixed(2)}</span>
              </div>

              <div className="hitch hitch-sub">
                <span>Service Charge</span>{' '}
                <span className="float-right">{serviceCharge.toFixed(2)}</span>
              </div>

              <div className="hitch hitch-sub">
                <span>Service VAT</span>{' '}
                <span className="float-right">{serviceVat.toFixed(2)}</span>
              </div>

              <div className="hitch hitch-sub">
                <span>Item VAT</span> <span className="float-right">{itemVat.toFixed(2)}</span>
              </div>

              <div
                className="hitch hitch-total"
                style={{
                  borderTop: '1px solid #ddd',
                  marginTop: '4px',
                  paddingTop: '4px',
                  fontWeight: 'bold',
                  color: '#111',
                }}
              >
                <span>Total Client Amt:</span>{' '}
                <span className="float-right">{totalAmount.toFixed(2)}</span>
              </div>
            </div>
          );
        },
      },
      {
        name: i18n.t('delivery_status'),
        width: '140px',
        cell: (row) => <StatusBadge status={DELIVERY_STATUS[row.delivery_status]} />,
        wrap: true,
      },
    ];

    if (hasApproved) {
      columns = [
        ...columns,
        {
          name: i18n.t('invoice_date'),
          width: '110px',
          cell: (row) => (row.invoice_date ? row.invoice_date : '————'),
          wrap: true,
        },
        {
          name: i18n.t('invoice'),
          width: '130px',
          cell: (row) => (
            <a
              className="button-table"
              href={`${apiUrl}auction_approval_ind_inv/pdf?auc=${row.id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FileSpreadsheet size={18} /> {i18n.t('invoice')}
            </a>
          ),
          wrap: true,
        },
        {
          name: i18n.t('client_details'),
          width: '250px',
          cell: (row) => {
            const collectionType = Number(row.collection_type);

            if (collectionType === 3) {
              return <div style={{ fontSize: '13px', color: '#666' }}>N/A</div>;
            }
            return (
              <div className="client-details">
                <div className="client-name">{`Client: ${row.client_name}` || 'Client: ——'}</div>
                <div className="bank-name">
                  {row.bank_name ? `Bank: ${row.bank_name}` : 'Bank: ——'}
                </div>
                <div className="account-number">
                  {row.bank_account ? `A/C: ${row.bank_account}` : 'A/C: ——'}
                </div>
              </div>
            );
          },
          wrap: true,
          center: false,
        },
        {
          name: i18n.t('approval_remarks'),
          width: '250px',
          cell: (row) => (
            <ExpandableText
              text={row.approval_remarks}
              limit={40}
              readMoreLabel={i18n.t('read_more')}
              showLessLabel={i18n.t('show_less')}
            />
          ),
          wrap: true,
        },

        {
          name: i18n.t('approval_doc'),
          width: '150px',
          cell: (row) =>
            row.file_approved_doc ? (
              <a
                className="button-table"
                href={`${imageUrl}uploads/${row.file_approved_doc}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FileSpreadsheet size={18} /> {i18n.t('attachment')}
              </a>
            ) : (
              i18n.t('no_document')
            ),
          wrap: true,
        },
      ];
    }

    if (hasCompleted) {
      columns = [
        ...columns,

        {
          name: i18n.t('bank_info'),
          width: '180px',
          cell: (row) => (
            <div>
              <div>
                <strong>Bank: {row.bank_name ?? 'N/A'}</strong>
              </div>
              <div style={{ fontSize: '14px', color: '#666' }}>
                Ac No: {row.bank_account ?? 'N/A'}
              </div>
            </div>
          ),
          wrap: true,
        },
        {
          name: i18n.t('settlement_doc'),
          width: '140px',
          cell: (row) =>
            row.settlement_doc ? (
              <a
                className="button-table"
                href={`${imageUrl}uploads/wallet/receipt/${row.settlement_doc}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FileSpreadsheet size={18} /> {i18n.t('document')}
              </a>
            ) : (
              i18n.t('no_document')
            ),
          wrap: true,
        },
        {
          name: i18n.t('settlement_remarks'),
          minWidth: '150px',
          cell: (row) => (
            <ExpandableText
              text={row.settlement_remarks}
              limit={40}
              readMoreLabel={i18n.t('read_more')}
              showLessLabel={i18n.t('show_less')}
            />
          ),
        },
      ];
    }
    if (hasFundAdded) {
      columns = [
        ...columns,
        ...(user.role === 'F'
          ? [
              {
                name: i18n.t('action'),
                width: '140px',
                cell: (row) => (
                  <button
                    className="button-table"
                    onClick={() => this.setState({ showDeduct: true, selectedRow: row })}
                  >
                    {i18n.t('fund_deduct')}
                  </button>
                ),
              },
            ]
          : []),
      ];
    }

    if (user.role === 'C') {
      columns = columns.filter((col) => col.key !== 'bid_details');
    }

    return columns;
  };
  async getDeliveryAuctions() {
    this.setState({ is_loading: true });
    let { limit, page, status, groupId } = this.state;
    const queryStatus = status === 'all' ? null : status;
    const q = { page, limit, status: queryStatus };

    // Update URL
    this.updateUrlQuery(q);

    let response = await getDeliveryAuctions({ ...q, groupId });
    if (response.success) {
      let deliveryAuctions = response.data;
      let meta = response.meta;

      this.setState({
        deliveryAuctions,
        meta,
        is_loading: false,
      });
    }
    this.setState({ is_loading: false });
  }
  getMeta() {
    const { meta } = this.state;
    return {
      organizationName: meta?.organization?.name || 'N/A',
      totalAuctions: meta?.total_records || 0,
      totalAmount: meta?.grand_total || 0,
      organizationUrl: `${imageUrl}uploads/organization/${meta?.organization?.image_url}` || null,
    };
  }

  onChangePage = (page) => {
    this.setState({ page: page }, () => {
      this.getDeliveryAuctions();
    });
  };

  onChangeRowsPerPage = (limit) => {
    this.setState({ limit: limit, page: 1 }, () => {
      this.getDeliveryAuctions();
    });
  };
  handleCheckboxChange = (row) => {
    this.setState((prev) => {
      const isSelected = prev.selectedIds.includes(row.id);

      const selectedIds = isSelected
        ? prev.selectedIds.filter((id) => id !== row.id)
        : [...prev.selectedIds, row.id];

      const selectedRows = isSelected
        ? prev.selectedRows.filter((r) => r.id !== row.id)
        : [...prev.selectedRows, row];

      const selectedSum = selectedRows.reduce((sum, r) => sum + Number(r.bid_amount || 0), 0);

      return { selectedIds, selectedRows, selectedSum };
    });
  };

  handleCheckAll = (payments) => {
    this.setState((prev) => {
      // Filter only eligible rows
      const eligiblePayments = payments.filter((p) => {
        return !(
          this.state.status === 'fundAdded' &&
          Number(p.client_amount) < Number(p.total_amount) &&
          Number(p.paid_amount) === Number(p.total_amount)
        );
      });

      const eligibleIds = eligiblePayments.map((p) => p.id);

      const allSelected =
        prev.selectedIds.length === eligibleIds.length &&
        eligibleIds.every((id) => prev.selectedIds.includes(id));

      const selectedIds = allSelected ? [] : eligibleIds;
      const selectedRows = allSelected ? [] : eligiblePayments;

      // Calculate sum only for eligible rows
      const selectedSum = allSelected
        ? 0
        : eligiblePayments.reduce((sum, payment) => sum + (payment.bid_amount || 0), 0);

      return { selectedIds, selectedRows, selectedSum };
    });
  };

  handleApprove = () => {
    this.setState({
      showApprove: true,
    });
  };

  showBulkDeductModal = () => {
    // Update state and show modal
    this.setState({
      showBulkDeduct: true,
    });
  };

  handleBulkFundDeduct = () => {
    // Update state and show modal
    this.setState({
      // showBulkDeduct: true,
    });
  };

  handleFinanceSettlement = () => {
    const { meta, selectedIds, deliveryAuctions } = this.state;

    // Validate if items are selected
    if (!selectedIds.length) {
      swal('Warning', 'Please select at least one auction to proceed.', 'warning');
      return;
    }

    // Validate if meta.group exists
    if (!meta.group) {
      swal('Error', 'Group information is not available.', 'error');
      return;
    }

    // Get selected auctions for detailed calculations
    const selectedAuctions = deliveryAuctions.filter((auction) => selectedIds.includes(auction.id));

    // Calculate base totals from selected auctions
    const totals = selectedAuctions.reduce(
      (acc, auction) => {
        acc.bidAmount += Number(auction.bid_amount || 0);
        // Only include pre-calculated values if the corresponding flags are true
        acc.serviceCharge += meta.group.is_service_charge_included
          ? Number(auction.service_charge || 0)
          : 0;
        acc.itemAmountVat += meta.group.is_vat_included ? Number(auction.item_amount_vat || 0) : 0;
        acc.vatServiceCharge += meta.group.is_service_charge_vat_included
          ? Number(auction.vat_service_charge || 0)
          : 0;
        return acc;
      },
      {
        bidAmount: 0,
        serviceCharge: 0,
        itemAmountVat: 0,
        vatServiceCharge: 0,
      }
    );

    // Calculate total amount based on included components
    const totalAmount =
      totals.bidAmount + totals.serviceCharge + totals.itemAmountVat + totals.vatServiceCharge;

    // Handle service charge parsing (similar to PHP logic)
    const parseServiceCharge = (rawServiceCharge) => {
      if (!rawServiceCharge) return { value: 0, isPercent: false };

      const rawValue = String(rawServiceCharge);
      const isPercent = rawValue.includes('%');

      if (isPercent) {
        // Remove % and convert to number
        const numericValue = parseFloat(rawValue.replace('%', '')) || 0;
        return { value: numericValue, isPercent: true };
      } else {
        // Direct numeric value
        return { value: parseFloat(rawValue) || 0, isPercent: false };
      }
    };

    // Parse service charge from meta
    const serviceChargeInfo = parseServiceCharge(meta.group.service_charge);

    // Initialize paymentApproval object with conditional totals
    let paymentApproval = {
      bidAmount: Number(totals.bidAmount).toFixed(3),
      isServiceChargeIncluded: Boolean(Number(meta.group.is_service_charge_included || 0)),
      isServiceChargeVatIncluded: Boolean(Number(meta.group.is_service_charge_vat_included || 0)),
      isVatIncluded: Boolean(Number(meta.group.is_vat_included || 0)),
      clientName: meta.group.client_name || '',
      bankName: meta.group.bank_name || '',
      bankAccount: meta.group.bank_account || '',
      // Conditional calculations based on flags
      vat: meta.group.is_vat_included ? Number(totals.itemAmountVat).toFixed(3) : '0.000',
      serviceCharge: meta.group.is_service_charge_included
        ? Number(totals.serviceCharge).toFixed(3)
        : '0.000',
      vatServiceCharge: meta.group.is_service_charge_vat_included
        ? Number(totals.vatServiceCharge).toFixed(3)
        : '0.000',
      totalPayable: Number(totalAmount).toFixed(3),
      // Add group configuration for reference
      vatRate: meta.group.vat || '0',
      serviceChargeRate: meta.group.service_charge || '0%',
      serviceChargeValue: serviceChargeInfo.value,
      serviceChargeIsPercent: serviceChargeInfo.isPercent,
      selectedCount: selectedIds.length,
    };

    // Update state and show modal
    this.setState({
      paymentApproval,
      showSettlement: true,
    });
  };

  handleReject = () => {
    this.setState({
      showReject: true,
    });
  };

  submitReject = async () => {
    const { selectedIds, rejectNote } = this.state;

    if (!rejectNote || rejectNote.trim() === '') {
      this.setState({ rejectNoteError: 'Reject note is required.' });
      return;
    }

    const payload = {
      selected_ids: selectedIds,
      reject_reason: rejectNote,
    };

    try {
      this.setState({ is_loading: true });

      const response = await auctionReject(payload);

      if (response && response.success) {
        swal(i18n.t('success'), i18n.t('auction_rejected'), 'success');
        this.setState(
          {
            showReject: false,
            selectedIds: [],
            selectedSum: 0,
            paymentApproval: {},
            rejectNote: null,
            is_loading: false,
          },
          () => {
            this.getDeliveryAuctions(); // refresh data after rejection
          }
        );
      } else {
        swal(i18n.t('failed'), response.message || 'Something went wrong', 'error');
        this.setState({ is_loading: false });
      }
    } catch (err) {
      console.error(err);
      this.setState({ is_loading: false });
      swal(i18n.t('failed'), 'Failed to reject auction(s)', 'error');
    }
  };

  handleCancel = () => {
    this.setState({
      showReject: false,
      selectedIds: [],
      selectedSum: 0,
      paymentApproval: {},
    });
  };

  handleCancelSwap = () => {
    this.setState({ showSwap: false, selectedRow: null });
  };

  submitSwap = async () => {
    const { selectedRow } = this.state;
    if (!selectedRow) return;

    this.setState({ action_loading: true });

    try {
      // Prepare data for API
      const payload = {
        auction: selectedRow.id,
        group: selectedRow.group_id,
        user: selectedRow.user_id,
        debit: selectedRow.total_amount,
        type: 'wallet_swap',
        status: 'F',
      };

      const response = await swapWallet(payload);
      if (response.success) {
        this.setState({
          showSwap: false,
          selectedIds: [],
        });
        this.getDeliveryAuctions();
        swal(i18n.t('success'), i18n.t('data_loaded_successfully'), 'success');
      } else {
        swal(i18n.t('failed'), response.message || i18n.t('something_went_wrong'), 'error');
      }
    } catch (error) {
      console.error('Error fetching auctions:', error);
      swal(i18n.t('failed'), i18n.t('failed_to_load_data'), 'error');

      // Optionally show error toast/message
    } finally {
      this.setState({ action_loading: false, showSwap: false });
    }
  };

  handleDownload = async (fileType) => {
    this.setState({ exportLoading: true });
    try {
      await downloadFile({
        url: `${apiUrl}v2/report/client-payment`,
        params: {
          deliveryStatus: DeliveryStatus[this.state.status],
          groupId: this.state.groupId,
          fileType,
        },
        token: user.token,
        fileType,
        fileName: 'Auction_Transaction',
      });
    } finally {
      this.setState({ exportLoading: false });
    }
  };

  render() {
    const { deliveryAuctions, status, selectedIds, meta, exportLoading, selectedRows } = this.state;
    const { organizationName, organizationUrl, totalAuctions, totalAmount } = this.getMeta();

    return (
      <React.Fragment>
        <HeaderBanner
          title={i18n.t('auction_details')}
          // subtitle={i18n.t('track_your_successful_bid')}
        />
        <section className="mt-5">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>

                    <div className="header-action">
                      {/* Back Button */}
                      <button
                        className="button1 button1-gradient button1-back"
                        onClick={() =>
                          this.props.navigate(`/auction_approval?status=${this.state.status}`)
                        }
                      >
                        <ArrowLeft size={18} className="icon" />
                        <span>{i18n.t('back')}</span>
                      </button>
                      <NewDropdown
                        label={i18n.t('export')}
                        loading={exportLoading}
                        icon={Download}
                        items={[
                          {
                            label: i18n.t('excel'),
                            icon: FileSpreadsheet,
                            onClick: () => this.handleDownload('excel'),
                          },
                          {
                            label: i18n.t('pdf'),
                            icon: Printer,
                            disabled: true,
                          },
                        ]}
                      />
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="page-header">
                      <div className="header-container">
                        <AvatarIcon
                          organizationName={organizationName}
                          avatarUrl={organizationUrl}
                          label="Client Name"
                        />

                        <div className="stats-section">
                          <div className="stat-box">
                            <div className="stat-label">{i18n.t('total_auctions')}</div>
                            <div className="stat-value">{totalAuctions}</div>
                          </div>

                          <div className="stat-box">
                            <div className="stat-label">{i18n.t('total_amount')}</div>
                            <div className="stat-value amount">{totalAmount.toFixed(3)}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`warning-box-wrapper ${
                        status === 'pending' && selectedIds.length > 0 ? 'open' : 'exit'
                      }`}
                    >
                      <WarningBox
                        data={selectedIds}
                        message={i18n.t('auction_approval_warning_message')}
                        onApprove={() => this.handleApprove()}
                        onReject={() => this.handleReject()}
                      />
                    </div>
                    <div
                      className={`warning-box-wrapper ${
                        status === 'fundAdded' && selectedIds.length > 0 ? 'open' : 'exit'
                      }`}
                    >
                      <WarningBox
                        data={selectedIds}
                        message="Fund Deduct Warning. Please confirm your action."
                        onApprove={() => this.showBulkDeductModal()}
                        approveText="Fund Deduction"
                      />
                    </div>
                    <div
                      className={`warning-box-wrapper ${
                        status === 'fundDeduct' && selectedIds.length > 0 ? 'open' : 'exit'
                      }`}
                    >
                      <WarningBox
                        data={selectedIds}
                        message="Payment Approval Warning. Please confirm your action."
                        onApprove={() => this.handleFinanceSettlement()}
                        approveText="Payment Approval"
                      />
                    </div>

                    <div className="Data-Listing">
                      {this.state.is_loading ? (
                        <TableSkeleton columns={6} rows={10} />
                      ) : deliveryAuctions.length ? (
                        <DataTable
                          responsive={true}
                          columns={this.getColumns()}
                          data={deliveryAuctions}
                          customStyles={tableStyles}
                          highlightOnHover
                          pagination
                          paginationServer
                          paginationTotalRows={this.state.total}
                          paginationPerPage={this.state.limit}
                          paginationDefaultPage={this.state.page}
                          paginationRowsPerPageOptions={[15, 25, 50, 100]}
                          paginationComponentOptions={{
                            rowsPerPageText: i18n.t('rows_per_page'),
                            rangeSeparatorText: i18n.t('out'),
                          }}
                          onChangePage={this.onChangePage}
                          onChangeRowsPerPage={this.onChangeRowsPerPage}
                        />
                      ) : (
                        <NoData
                          message={i18n.t('no_data_available')}
                          actionText={i18n.t('refresh')}
                          onAction={this.getDeliveryAuctions.bind(this)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <AuctionApproveModal
          user={user}
          show={this.state.showApprove}
          selectedIds={this.state.selectedIds}
          isClientEnrollment={meta.group?.is_client_enrollment}
          groupId={this.state.groupId}
          onClose={() => this.setState({ showApprove: false })}
          onConfirm={(note) => this.handleApprove(note)}
          onSuccess={() => {
            this.setState({ showApprove: false, selectedIds: [], paymentApproval: {} }, () => {
              this.getDeliveryAuctions(); // refresh table after approve
            });
          }}
        />

        <ConfirmModal
          show={this.state.showReject}
          onClose={this.handleCancel}
          title={'Reject Confirmation'}
          message={'Are you sure you want to reject this item?'}
          onConfirm={this.submitReject}
          onCancel={this.handleCancel}
          confirmText={'Reject'}
          cancelText="Cancel"
          loading={this.state.action_loading}
        >
          <div className="reject-note-container">
            <p>Please provide the reason for rejecting the refund process.</p>
            <textarea
              id="rejectNote"
              value={this.state.rejectNote || ''}
              onChange={(e) => {
                const value = e.target.value;
                this.setState({
                  rejectNote: value,
                  rejectNoteError: value.trim() === '' ? 'Reject note is required.' : null,
                });
              }}
              placeholder="Enter reason for rejection"
              rows={3}
              className={`reject-note-textarea ${this.state.rejectNoteError ? 'is-invalid' : ''}`}
            />
            {this.state.rejectNoteError && (
              <p className="error-text">{this.state.rejectNoteError}</p>
            )}
          </div>
        </ConfirmModal>

        <ConfirmModal
          show={this.state.showSwap}
          onClose={this.handleCancelSwap}
          title={'Wallet Swap Confirmation'}
          message={'Are you sure you want to swap this amount from the wallet?'}
          onConfirm={this.submitSwap}
          onCancel={this.handleCancelSwap}
          confirmText={'Swap'}
          cancelText="Cancel"
          loading={this.state.action_loading}
        ></ConfirmModal>

        <AuctionFundDeductModal
          show={this.state.showDeduct}
          auction={this.state.selectedRow}
          onClose={() => this.setState({ showDeduct: false })}
          onConfirm={(note) => this.handleApprove(note)}
          onSuccess={() => {
            this.setState({ showDeduct: false, selectedRow: null }, () => {
              this.getDeliveryAuctions();
            });
          }}
        />

        <BulkFundDeductList
          show={this.state.showBulkDeduct}
          selectedRows={selectedRows}
          onClose={() => this.setState({ showBulkDeduct: false })}
          onSuccess={() => {
            this.setState({ showBulkDeduct: false, selectedRows: [] }, () => {
              this.getDeliveryAuctions();
            });
          }}
        />

        <AuctionSettleModal
          show={this.state.showSettlement}
          selectedIds={this.state.selectedIds}
          paymentApproval={this.state.paymentApproval}
          group={meta.group || {}}
          onClose={() => this.setState({ showSettlement: false })}
          onConfirm={(note) => this.handleFinanceSettlement(note)}
          onSuccess={() => {
            this.setState(
              {
                showSettlement: false,
                selectedIds: [],
                selectedSum: 0,
                paymentApproval: {},
                deliveryAuctions: [],
              },
              () => {
                this.getDeliveryAuctions(); // refresh table after approve
              }
            );
          }}
        />
      </React.Fragment>
    );
  }
}
export default withRouter(AuctionApprovalDeatil);
